import React from 'react'
// import './MapMarker.styles.css'

const IconMapPin = ({ onClick }) => (
  <div onClick={onClick} className="mapMarker">
    <svg
      width={17}
      height={24}
      viewBox="0 0 17 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.5357 17.0935C15.1631 14.6013 16.6667 12.2989 16.6667 8.88028C16.6667 4.20586 13.662 0.00585938 8.33333 0.00585938C3.00467 0.00585938 0 4.20586 0 9.00586C0 12.4606 1.64449 14.8102 3.48329 17.4374L3.71619 17.7705C5.64667 20.5351 8.4856 24.0059 8.4856 24.0059C8.4856 24.0059 11.3095 20.5351 13.0952 17.7705C13.2423 17.5427 13.3896 17.3173 13.5357 17.0935ZM8.33312 11.3392C9.98997 11.3392 11.3331 9.99604 11.3331 8.33919C11.3331 6.68233 9.98997 5.33919 8.33312 5.33919C6.67626 5.33919 5.33312 6.68233 5.33312 8.33919C5.33312 9.99604 6.67626 11.3392 8.33312 11.3392Z"
        fill="#DF0024"
      />
    </svg>
  </div>
)

export default IconMapPin
